import { useQuery } from '@tanstack/react-query';
import { api } from '../api-client.config';
import { queryKeys } from '../react-query.config';

interface FeedSport {
  externalId: string;
  name: string;
  code: string;
}

interface FeedSportsResponse {
  sports: FeedSport[];
}

export type { FeedSport };

export const getFeedSports = async (): Promise<FeedSport[]> => {
  const response = (await api.get('/feed/sports')) as FeedSportsResponse;
  return response.sports || [];
};

export const useGetFeedSportsQuery = (options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: queryKeys.feed.sports(),
    queryFn: getFeedSports,
    staleTime: 10 * 60 * 1000, // 10 minutes - sports rarely change
    enabled: options?.enabled !== false,
  });
};
